import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#F1F4FA" d="M95.5 37a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M22.12 11.231a1.5 1.5 0 0 1 0 2.122l-9.993 9.994a1.5 1.5 0 0 1-2.122-2.122L20 11.231a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M10.005 11.231a1.5 1.5 0 0 1 2.122 0l9.994 9.994a1.5 1.5 0 0 1-2.122 2.122l-9.994-9.994a1.5 1.5 0 0 1 0-2.122"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      d="M12.563 85.32a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M101.567 68a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V69.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M93 76.567a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H94.5a1.5 1.5 0 0 1-1.5-1.5M80 102a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      d="M34.396 12h47.208C82.926 12 84 13.098 84 14.452V94H32V14.452C32 13.099 33.073 12 34.396 12"
    />
    <path
      fill="#ACB8C3"
      d="M50.401 21H42.6a.6.6 0 0 0-.599.599V29.4c0 .331.268.599.599.599H50.4c.331 0 .599-.268.599-.599V21.6a.6.6 0 0 0-.599-.599M50.401 42H42.6a.6.6 0 0 0-.599.599V50.4c0 .331.268.599.599.599H50.4c.331 0 .599-.268.599-.599V42.6a.6.6 0 0 0-.599-.599M50.401 63H42.6a.6.6 0 0 0-.599.599V71.4c0 .331.268.599.599.599H50.4c.331 0 .599-.268.599-.599V63.6a.6.6 0 0 0-.599-.599M73.401 21H65.6a.6.6 0 0 0-.599.599V29.4c0 .331.268.599.599.599H73.4c.331 0 .599-.268.599-.599V21.6a.6.6 0 0 0-.599-.599M73.401 42H65.6a.6.6 0 0 0-.599.599V50.4c0 .331.268.599.599.599H73.4c.331 0 .599-.268.599-.599V42.6a.6.6 0 0 0-.599-.599M73.401 63H65.6a.6.6 0 0 0-.599.599V71.4c0 .331.268.599.599.599H73.4c.331 0 .599-.268.599-.599V63.6a.6.6 0 0 0-.599-.599"
    />
    <path
      fill="#F1F4FA"
      d="M53.38 78h9.24c1.313 0 2.38.986 2.38 2.202V93H51V80.202C51 78.986 52.066 78 53.38 78"
    />
    <path
      fill="#ACB8C3"
      fillRule="evenodd"
      d="M22 93.5c0-1.38 1.16-2.5 2.592-2.5h67.814c1.43 0 2.591 1.12 2.591 2.5s-1.16 2.5-2.591 2.5H24.59C23.161 96 22 94.88 22 93.5"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconApartmentGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconApartmentGreyscale);
export default Memo;
